import { ICellRendererParams } from "ag-grid-community";
import dayjs from "dayjs";

export const DateRenderer = (p: ICellRendererParams) => dayjs(p.value).format("DD/MM/YYYY");
